import { ModalComponent } from 'new/routes/RouterManager';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import {
  UPDATE_CATALOG_CONFIG_REQUEST,
  UPDATE_GEN_AI_CONFIG_REQUEST,
} from 'js/constants/actionTypes';
import { useModals } from 'new/hooks/useModals';
import { EXTERNAL_INTEGRATIONS, integrationTypes } from 'js/constants/externalIntegrations';
import { updateCatalogConfig } from 'js/actions/catalogConfigs';
import { updateGenAiConfig } from 'js/actions/genAiConfigs';
import useDidUpdateEffect from 'new/hooks/useDidUpdateEffect';
import React, { useEffect } from 'react';
import { Typography } from '@mui/material';

export const DeactivateIntegration: ModalComponent = ({
  activeIntegration,
  integrationType,
  currentIntegration,
  setLoading,
  setModalActions,
}) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();
  const isLoading = useIsLoading(UPDATE_CATALOG_CONFIG_REQUEST, UPDATE_GEN_AI_CONFIG_REQUEST);
  const { closeModal } = useModals();

  const update =
    integrationType === integrationTypes.gen_ai ? updateGenAiConfig : updateCatalogConfig;

  const getIntegrationDisplayName = (name) => EXTERNAL_INTEGRATIONS[name]?.meta.displayName || name;

  const actionSuccess = () => {
    closeModal(DeactivateIntegration.modalConfig.name);
  };

  const onConfirm = async () => {
    await dispatch(
      update(activeIntegration.id, {
        status: 'PAUSED',
      }),
    );
    await dispatch(
      update(currentIntegration.id, {
        status: 'ACTIVE',
      }),
    );
    actionSuccess();
  };

  useDidUpdateEffect(() => {
    setLoading(isLoading);
  }, [isLoading]);

  useEffect(() => {
    setModalActions({
      ok: {
        onClick: onConfirm,
      },
    });
  }, []);

  return (
    <div>
      <Typography textAlign="center" variant="body1">
        Activating <b>{getIntegrationDisplayName(currentIntegration.name)}</b> will cause{' '}
        <b>{getIntegrationDisplayName(activeIntegration.name)}</b> to be deactivated. Are you sure
        you want to continue?
      </Typography>
    </div>
  );
};

DeactivateIntegration.modalConfig = {
  name: 'integrations.DeactivateIntegration',
  title: 'Deactivate integration',
  maxWidth: 'md',
};
